import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';
export const updatePropertiesOnCrmObject = (updatedProperties, contentCrmObject) => {
  const updatedContentCrmObject = Object.assign({}, contentCrmObject);
  const properties = Object.assign({}, updatedContentCrmObject.properties, updatedProperties);
  updatedContentCrmObject.properties = properties;
  return updatedContentCrmObject;
};
export const removeFromMultiLanguageGroup = contentCrmObject => {
  const updatedContentCrmObject = updatePropertiesOnCrmObject({
    [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: {
      value: undefined,
      rawValue: undefined
    }
  }, contentCrmObject);
  if (contentCrmObject.associatedObjects && contentCrmObject.associatedObjects.OBJECT_TO_CONTENT_GROUP) {
    updatedContentCrmObject.associatedObjects = {
      OBJECT_TO_CONTENT_GROUP: [...contentCrmObject.associatedObjects.OBJECT_TO_CONTENT_GROUP]
    };
  }
  return updatedContentCrmObject;
};
export const convertToLanguageGroupPrimary = contentCrmObject => {
  const updatedContentCrmObject = updatePropertiesOnCrmObject({
    [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: {
      value: undefined,
      rawValue: undefined
    }
  }, contentCrmObject);
  if (updatedContentCrmObject.associatedObjects && updatedContentCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS) {
    const newTranslatedFromId = getContentPropertyValue(updatedContentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.ID);
    const updatedAssociatedObjects = updatedContentCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS.map(translation => {
      return updatePropertiesOnCrmObject({
        [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: {
          value: `${newTranslatedFromId}`,
          rawValue: newTranslatedFromId
        }
      }, translation);
    });
    updatedContentCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS = updatedAssociatedObjects;
  }
  return updatedContentCrmObject;
};
export const switchLanguageGroupPrimary = (contentCrmObject, newPrimaryId) => {
  const updatedContentCrmObject = updatePropertiesOnCrmObject({
    [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: {
      value: `${newPrimaryId}`,
      rawValue: newPrimaryId
    }
  }, contentCrmObject);
  if (updatedContentCrmObject.associatedObjects && updatedContentCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS) {
    const updatedAssociatedObjects = updatedContentCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS.map(translation => {
      const updatedTranslatedFromIdValues = translation.objectId === newPrimaryId ? {
        value: undefined,
        rawValue: undefined
      } : {
        value: `${newPrimaryId}`,
        rawValue: newPrimaryId
      };
      return updatePropertiesOnCrmObject({
        [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: updatedTranslatedFromIdValues
      }, translation);
    });
    updatedContentCrmObject.associatedObjects.OBJECT_TO_TRANSLATIONS = updatedAssociatedObjects;
  }
  return updatedContentCrmObject;
};
export const createLanguageVariant = (contentCrmObject, newLanguageVariantData) => {
  const {
    language,
    objectId,
    portalId,
    translatedFromId
  } = newLanguageVariantData;
  const updatedContentCrmObject = Object.assign({}, contentCrmObject);
  const newLanguageVariation = {
    objectId,
    portalId,
    objectTypeId: contentCrmObject.objectTypeId,
    properties: Object.assign({}, contentCrmObject.properties, {
      [CONTENT_PLATFORM_PROPERTY_NAME.ID]: {
        rawValue: objectId,
        value: `${objectId}`
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: {
        rawValue: translatedFromId,
        value: `${translatedFromId}`
      },
      [CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE]: {
        rawValue: language,
        value: language
      }
    })
  };
  const updatedAssociatedObjects = Object.assign({}, updatedContentCrmObject.associatedObjects);
  if (updatedAssociatedObjects && updatedAssociatedObjects.OBJECT_TO_TRANSLATIONS) {
    updatedAssociatedObjects.OBJECT_TO_TRANSLATIONS.push(newLanguageVariation);
  } else {
    updatedAssociatedObjects.OBJECT_TO_TRANSLATIONS = [newLanguageVariation];
  }
  updatedContentCrmObject.associatedObjects = updatedAssociatedObjects;
  return updatedContentCrmObject;
};
export const addToLanguageGroup = (contentCrmObject, primaryId, selectedPrimaryContent) => {
  const updatedContentCrmObject = updatePropertiesOnCrmObject({
    [CONTENT_PLATFORM_PROPERTY_NAME.TRANSLATED_FROM_ID]: {
      value: `${primaryId}`,
      rawValue: primaryId
    }
  }, contentCrmObject);
  const translations = [selectedPrimaryContent];
  if (selectedPrimaryContent.associatedObjects && selectedPrimaryContent.associatedObjects.OBJECT_TO_TRANSLATIONS) {
    translations.push(...selectedPrimaryContent.associatedObjects.OBJECT_TO_TRANSLATIONS);
  }
  updatedContentCrmObject.associatedObjects = Object.assign({}, updatedContentCrmObject.associatedObjects, {
    OBJECT_TO_TRANSLATIONS: translations
  });
  return updatedContentCrmObject;
};
export const deleteContent = contentCrmObject => {
  const deletedAtDate = new Date();
  return updatePropertiesOnCrmObject({
    [CONTENT_PLATFORM_PROPERTY_NAME.ARCHIVED_AT]: {
      value: `${deletedAtDate}`,
      rawValue: deletedAtDate
    }
  }, contentCrmObject);
};
export const updateTitle = (contentCrmObject, updatedTitle) => {
  return updatePropertiesOnCrmObject({
    [CONTENT_PLATFORM_PROPERTY_NAME.NAME]: {
      value: updatedTitle,
      rawValue: updatedTitle
    }
  }, contentCrmObject);
};